import React, {FC} from 'react';
import {connect} from 'react-redux';

import {DataEventTrackingProvider} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingProvider';
import {
  OnboardingEventsEnum,
  trackEvent,
  TrackingTypesEnum,
} from '../../../../../libs/shared/core/src/services/tracking/tracking';
import {ResolveDispatchProps} from '../../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {LightUserThemeProvider} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getFirstTeamUserIsAdminOf} from '../../../../store/data/teams/teamsSelectors';
import {updateDepartmentMetadataAction} from '../../../../store/data/userMetadata/userMetadataActions';
import {useOnboardingModalState} from '../../../app/topBar/onboarding/onboardingContext';
import {OnboardingGuidesEnum} from '../../guide/onboardingGuideTypes';
import {AdminWizardPopover} from './adminWizardPopover';

/*
 * Props.
 */

interface AdminWizardPopoverContainerProps {
  panelId: AppPanelId;
}

type AdminWizardPopoverContainerComponentProps = AdminWizardPopoverContainerProps &
  ResolveDispatchProps<typeof mapDispatchToProps>;

/*
 * Component.
 */

const AdminWizardPopoverContainerComponent: FC<AdminWizardPopoverContainerComponentProps> = (props) => {
  const {updateDepartmentMetadata} = props;

  const {renderOnboardingGuideTransition, setOnboardingGuide, onboardingGuide} = useOnboardingModalState();
  const firstTeam = useAppSelector(getFirstTeamUserIsAdminOf);

  if (!firstTeam) {
    return null;
  }

  return (
    // TODO: Add dark mode support in slides (waiting on design.)
    <LightUserThemeProvider>
      <DataEventTrackingProvider context={{name: 'getting_started', payload: {}}}>
        <AdminWizardPopover
          panelId={props.panelId}
          team={firstTeam}
          onChangeDepartment={(department) => {
            trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.COMPLETED_IDENTITY_INFO);
            updateDepartmentMetadata(department);
          }}
          onClose={() => {
            setOnboardingGuide(undefined);
          }}
          isAdminWizardOpen={onboardingGuide === OnboardingGuidesEnum.ADMIN_WIZARD}
          renderAdminWizardTransition={(render) =>
            renderOnboardingGuideTransition(OnboardingGuidesEnum.ADMIN_WIZARD, render)
          }
        />
      </DataEventTrackingProvider>
    </LightUserThemeProvider>
  );
};

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updateDepartmentMetadata: updateDepartmentMetadataAction,
}));

export const AdminWizardPopoverContainer = connect(
  null,
  mapDispatchToProps,
)(AdminWizardPopoverContainerComponent);
